import { DASHBOARD_TITLE_TABS, HIERARCHY_TYPE, SIDE_TABS } from '~/app/constants.js';
// Redux imports
import { actions as appActions } from '~/app/redux/modules/app';
import { actions as returnListActions } from '~/app/redux/returnList/duck';
import { actions as formViewerActions } from '~/app/redux/modules/formViewer';

const setPreparerTabs = dispatch => {
  if (history.state.drilledDown) {
    history.pushState({ drilledDown: false }, null, '/dashboard');
  }
  dispatch(returnListActions.clearReturnsList());

  // Reset our YTY state
  dispatch(formViewerActions.setYTYReturns([], []));
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      '',
      false,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.WIDGETS,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      '',
      false,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

const setSuperAdminTabs = dispatch => {
  dispatch(
    appActions.setTitleTabProperties(
      'Accounts',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.OVERVIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      '',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

const setManageTabs = dispatch => {
  dispatch(
    appActions.setTitleTabProperties(
      'Overview',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.OVERVIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Preparers',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.WIDGETS,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      '',
      false,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

const setBusinessOwnerTabs = dispatch => {
  try {
    history.state.drilledDown !== undefined &&
      history.state.drilledDown !== false &&
      history.pushState({ drilledDown: false }, null, '/dashboard');
  } catch (e) {
    console.info('Could not read history state');
  }

  dispatch(
    appActions.setTitleTabProperties(
      'Offices',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.WIDGETS,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      '',
      false,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

const setSBTabs = dispatch => {
  try {
    history.state.drilledDown !== undefined &&
      history.state.drilledDown !== false &&
      history.pushState({ drilledDown: false }, null, '/dashboard');
  } catch (e) {
    console.info('Could not read history state');
  }

  dispatch(
    appActions.setTitleTabProperties(
      'Accounts',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Offices',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.WIDGETS,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

const setSBBTabs = dispatch => {
  try {
    history.state.drilledDown !== undefined &&
      history.state.drilledDown !== false &&
      history.pushState({ drilledDown: false }, null, '/dashboard');
  } catch (e) {
    console.info('Could not read history state');
  }

  dispatch(
    appActions.setTitleTabProperties(
      'Overview',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.OVERVIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Accounts',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.LIST_VIEW,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Offices',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.WIDGETS,
    ),
  );
  dispatch(
    appActions.setTitleTabProperties(
      'Tax Returns',
      true,
      SIDE_TABS.DASHBOARD_MAIN,
      DASHBOARD_TITLE_TABS.ACTIVE_RETURN,
    ),
  );
};

// Setup Dashboard State Objects for each specific Hierarchy Type
export const setTabs = (roleGroup, dispatch) => {
  switch (roleGroup) {
    case HIERARCHY_TYPE.PREPARER:
      setPreparerTabs(dispatch);
      break;
    case HIERARCHY_TYPE.FRANCHISE:
      setBusinessOwnerTabs(dispatch);
      break;
    case HIERARCHY_TYPE.EFIN:
      setManageTabs(dispatch);
      break;
    case HIERARCHY_TYPE.SSB:
      setSBBTabs(dispatch);
      break;
    case HIERARCHY_TYPE.SB:
      setSBTabs(dispatch);
      break;
    case HIERARCHY_TYPE.TECH_SUPPORT_SBA:
    case HIERARCHY_TYPE.TECH_SUPPORT:
    case HIERARCHY_TYPE.ADMIN:
      setSuperAdminTabs(dispatch);
      break;
  }
};
